// Write your code here
import './index.css'

const DestinationItem = props => {
  const {destination} = props
  const {imgUrl, name, id} = destination
  return (
    <li className="card">
      <img className="image" src={imgUrl} alt={name} />
      <p className="para">{name}</p>
    </li>
  )
}

export default DestinationItem
